import classNames from 'classnames';

import { CheckIcon } from 'fluxo-ui/icons';

import { LiveQuizQuestionStats } from '../../../types/index.ts';

import { optionAccents } from './optionAccents';

interface AnswerDistributionProps {
    stats: LiveQuizQuestionStats;
}

const AnswerDistribution: React.FC<AnswerDistributionProps> = ({ stats }) => {
    const maxCount = Math.max(1, ...stats.optionDistribution.map((option) => option.count));

    return (
        <div className="space-y-3">
            {stats.optionDistribution.map((option, index) => {
                const share = stats.totalResponses > 0 ? Math.round((option.count / stats.totalResponses) * 100) : 0;

                return (
                    <div key={option.optionId} className="flex items-center gap-3">
                        <span
                            className={classNames(
                                'grid place-items-center w-7 h-7 shrink-0 rounded text-xs font-bold text-white',
                                optionAccents[index % optionAccents.length].solid,
                            )}
                        >
                            {String.fromCharCode(65 + index)}
                        </span>

                        <div className="flex-1 min-w-0">
                            <div className="flex items-baseline justify-between gap-2 mb-1">
                                <span
                                    className={classNames('text-sm truncate', {
                                        'font-semibold text-slate-900 dark:text-white': option.isCorrect,
                                        'text-slate-600 dark:text-slate-400': !option.isCorrect,
                                    })}
                                >
                                    {option.text}
                                </span>
                                <span className="flex items-center gap-1.5 shrink-0 text-sm tabular-nums text-slate-500 dark:text-slate-400">
                                    {option.isCorrect && <CheckIcon className="w-4 h-4 text-emerald-600 dark:text-emerald-400" />}
                                    <span className="font-semibold text-slate-900 dark:text-white">{option.count}</span>
                                    <span>({share}%)</span>
                                </span>
                            </div>
                            <div className="h-2 rounded-full bg-slate-100 dark:bg-slate-800 overflow-hidden">
                                <div
                                    className={classNames(
                                        'h-full rounded-full transition-[width] duration-500 ease-out',
                                        option.isCorrect ? 'bg-emerald-500' : optionAccents[index % optionAccents.length].solid,
                                    )}
                                    style={{ width: `${(option.count / maxCount) * 100}%` }}
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default AnswerDistribution;
